module.exports = __webpack_public_path__ + "img/logo.13255bad.png";